import { render, staticRenderFns } from "./RedemptionsErrorDialog.vue?vue&type=template&id=66acef5a&scoped=true"
import script from "./RedemptionsErrorDialog.vue?vue&type=script&lang=js"
export * from "./RedemptionsErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./RedemptionsErrorDialog.vue?vue&type=style&index=0&id=66acef5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66acef5a",
  null
  
)

export default component.exports